export function getToken(){
  let token = window.sessionStorage.getItem('token')
  return token;
}



// WEBPACK FOOTER //
// ./src/config/token.js